import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  accounts: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  subAccounts: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "account",
  initialState,
  reducers: {
    getAccountsSuccess: (state, action) => {
      state.accounts = action.payload;
      state.loading = false;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getAccounts = ({ accessToken, page, limit }) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoading());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-account`,
        { headers }
      );
      dispatch(slice.actions.getAccountsSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};

export const getAllExpenses = async ({ accessToken }) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  const res = await axios.get(
    `${process.env.REACT_APP_BACKEND_API}/get-all-accounts`,
    { headers }
  );
  return res.data;
};
